
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/best-agency",
      function () {
        return require("private-next-pages/best-agency.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/best-agency"])
      });
    }
  